import React from "react";
import { useTranslation } from "react-i18next";

const SkillRequestCard = ({ request, onVote, isVoting }) => {
    const { t } = useTranslation();
    const score = request.upvotes - request.downvotes;

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    };

    return (
        <div className="flex items-start gap-3 p-3 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-colors">
            <div className="flex flex-col items-center gap-0.5 min-w-[40px]">
                <button
                    onClick={() => onVote(request.id, "up")}
                    disabled={isVoting}
                    className={`p-1 rounded transition-colors ${
                        request.userVote === "up"
                            ? "text-blue-600 bg-blue-50"
                            : "text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
                    </svg>
                </button>
                <span className={`text-sm font-semibold ${score > 0 ? "text-blue-600" : score < 0 ? "text-red-500" : "text-gray-500"}`}>
                    {score}
                </span>
                <button
                    onClick={() => onVote(request.id, "down")}
                    disabled={isVoting}
                    className={`p-1 rounded transition-colors ${
                        request.userVote === "down"
                            ? "text-red-500 bg-red-50"
                            : "text-gray-400 hover:text-red-500 hover:bg-red-50"
                    }`}
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
            </div>
            <div className="flex-1 min-w-0">
                <h4 className="font-medium text-gray-900 text-sm">{request.title}</h4>
                <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{request.description}</p>
                <div className="flex items-center gap-2 mt-1.5 text-xs text-gray-400">
                    <span>{request.user?.firstName} {request.user?.lastName}</span>
                    <span>·</span>
                    <span>{formatDate(request.createdAt)}</span>
                </div>
            </div>
        </div>
    );
};

export default SkillRequestCard;
